// Small pure helpers shared by the Events tab files.
import { formatFormDate } from "../../../../../utils/eventFormDateTime";
import { toDate } from "../../../lib/format";

const pad2 = (n) => String(n).padStart(2, "0");

/** Error values are a string or `{ message }` (mobile screens do the same). */
export { msg } from "../../../lib/errors";

/** <input type="date"> value "YYYY-MM-DD" -> the form's "MM/DD/YYYY" string. */
export function isoDateToForm(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  if (!m) return "";
  return formatFormDate(new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
}

/** <input type="time"> value "HH:mm" -> the form's "h:mm AM/PM" string. */
export function isoTimeToForm(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm || "");
  if (!m) return "";
  const h = Number(m[1]);
  return `${h % 12 || 12}:${m[2]} ${h >= 12 ? "PM" : "AM"}`;
}

/** Event start_date -> { date: "YYYY-MM-DD", time: "HH:mm" } for the native inputs. */
export function startToInputs(value) {
  const d = toDate(value);
  if (!d) return { date: "", time: "" };
  return {
    date: `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`,
    time: `${pad2(d.getHours())}:${pad2(d.getMinutes())}`,
  };
}
